import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  exchangeCodeForTokens,
  parseHashExchangeCode,
  saveTokens,
} from "./auth";

function AuthCallbackPage() {
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const exchanging = useRef(false);

  useEffect(() => {
    const code = parseHashExchangeCode(window.location.hash);

    if (!code) {
      setError("No exchange code found in the URL.");
      return;
    }

    if (exchanging.current) {
      return;
    }

    exchanging.current = true;

    // Remove the code from browser URL
    window.history.replaceState(
      null,
      "",
      "/auth/callback"
    );

    exchangeCodeForTokens(code)
      .then((tokens) => {
        // Save SSO tokens
        saveTokens(tokens);

        // Mark application as logged in
        localStorage.setItem(
          "isLoggedIn",
          "true"
        );

        // Redirect to application
        navigate("/home", {
          replace: true,
        });
      })
      .catch((err) => {
        console.error(
          "SSO callback failed:",
          err
        );

        setError(
          err instanceof Error
            ? err.message
            : "Code exchange failed."
        );

        exchanging.current = false;
      });
  }, [navigate]);

  return (
    <main className="page">
      <section className="panel">

        {error ? (
          <>
            <p className="status bad">
              Callback failed
            </p>

            <p>{error}</p>

            <div className="actions">
              <button
                type="button"
                onClick={() =>
                  navigate("/login", {
                    replace: true,
                  })
                }
              >
                Back to Login
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="status">
              Completing sign-in…
            </p>

            <p className="hint">
              Please wait while we complete your
              SSO authentication.
            </p>
          </>
        )}

      </section>
    </main>
  );
}

export default AuthCallbackPage;